<template>
  <layout-register :step="step" :title-step="titlePage">
    <template #description-page>
      {{ $t('m36') }}
      <strong>{{ phoneNumber ? '+' + phoneNumber : '' }}</strong>
    </template>
    <form @submit="sendCode">
      <div class="otp-row mx-auto">
        <a-otp-input
          v-model="form.code.value"
          input-classes="otp-input"
          input-type="text"
          separator=" "
          @keyup="evaluateInput"
          :error="form.code.error.length > 0"
          :errorMessage="form.code.error"
        />
      </div>

      <p class="mb-4">
        <template v-if="count === 0">
          {{ $t('m37') }}
          <a class="pointer" role="button" tabindex="0" @click="sendPhoneRetry">
            {{ $t('m38') }}
          </a>
        </template>
        <template v-else> {{ count }}{{ $t('m39') }} </template>
      </p>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-sm-12 col-12 with-go-back">
          <div @click="goBack" class="go-back">
            <img src="../assets/icons/nav-blue-ic-arrow-left.png" />
            <span>{{ $t('m40') }}</span>
          </div>
          <a-btn
            class="next-step-button"
            primary
            type="submit"
            :loading="loadingBtn"
          >
            {{ $t('m41') }}
          </a-btn>
        </div>
      </div>
    </form>
  </layout-register>
</template>

<script>
import ABtn from '@/components/ui/ABtn';
import AOtpInput from '@/components/ui/AOtpInput';
import { validator } from '@/mixins/validator.js';

export default {
  name: 'PhoneVerify',
  components: {
    ABtn,
    AOtpInput,
  },
  mixins: [validator],
  data() {
    return {
      code: '',
      phoneNumber: '',
      step: 2,
      titlePage: this.$t('m177'),
      loadingBtn: false,
      retryTime: 30,
      count: 0,
      form: {
        code: {
          value: '',
          error: '',
          rules: [],
        },
      },
    };
  },
  created() {
    this.$store.dispatch('register/profile').then(({ phoneNumber }) => {
      this.phoneNumber = phoneNumber;
    });
  },
  mounted() {
    this.form.code.rules = [this.rules.required, this.rules.phoneVerify];
  },
  methods: {
    sendPhoneRetry() {
      this.count = this.retryTime;
      this.startCounter();
      this.$store.dispatch('register/phoneRetry');
    },
    startCounter() {
      setTimeout(() => {
        if (this.count > 0) {
          this.count--;
          this.startCounter();
        }
      }, 1000);
    },
    sendCode(e) {
      if (this.validateForm()) {
        this.loadingBtn = true;
        this.$store
          .dispatch('register/phoneVerify', { code: this.form.code.value })
          .then(resp => {
            if (resp.registrationStep === 'DOCUMENT') {
              this.$router.push({ name: resp.registrationStep });
            } else {
              this.$toast.warning(
                'El código es incorrecto, intente escribirlo nuevamente',
              );
            }
          })
          .finally(() => {
            this.loadingBtn = false;
          });
      }
      e.preventDefault();
    },
    goBack() {
      this.$store.dispatch('register/setRegistrationStep', 'PHONE_NUMBER');
      setTimeout(() => {
        this.$router.push({ name: 'PHONE_NUMBER' });
      }, 100);
    },
  },
};
</script>
